import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ProbateSubscriber,
  ProbateSubscriberDetail,
  SubscriberUpdate,
} from '@app/core/models/subscriber.model';
import { SubscriberCreatePayloadSnake } from '@shared/interfaces';
import {} from '@app/core/models/subscriber.model';
import { catchError, Observable, of, tap } from 'rxjs';
import { StorageService } from '../../../shared/services/storage.service';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';
import { StorageKey } from '@shared/enums/storage-keys.enum';

@Injectable({ providedIn: 'root' })
export class SubscribersHttpService {
  private readonly _http = inject(HttpClient);
  private readonly _storage = inject(StorageService);
  private readonly _tenantService = inject(TenantFacadeService);

  public updateSubscriber(
    probateId: number,
    subscriberId: number,
    updateData: SubscriberUpdate,
  ) {
    return this._http.patch<ProbateSubscriberDetail>(
      `${this._tenantService.tenantApiUrl()}/${this._tenantService.tenantApiPrefix()}/${probateId}/subscribers/${subscriberId}/`,
      updateData,
    );
  }

  public createSubscriber(
    probateId: number,
    createData: SubscriberCreatePayloadSnake,
  ) {
    return this._http.post<ProbateSubscriberDetail>(
      `${this._tenantService.tenantApiUrl()}/${this._tenantService.tenantApiPrefix()}/${probateId}/subscribers/`,
      createData,
    );
  }

  public getSubscribers(probateId: number) {
    return this._http
      .get<
        ProbateSubscriber[]
      >(`${this._tenantService.tenantApiUrl()}/${this._tenantService.tenantApiPrefix()}/${probateId}/subscribers/`)
      .pipe(
        tap((subscribers) => {
          this._storage.save(StorageKey.subscribers, subscribers);
        }),
      );
  }

  public getSubscriber(probateId: number, subscriberId: number) {
    return this._http
      .get<ProbateSubscriberDetail>(
        `${this._tenantService.tenantApiUrl()}/${this._tenantService.tenantApiPrefix()}/${probateId}/subscribers/${subscriberId}/`,
      )
      .pipe(
        catchError(() => {
          return of(null);
        }),
      );
  }

  public deleteSubscriber(
    probateId: number,
    subscriberId: number,
  ): Observable<null> {
    return this._http.delete<null>(
      `${this._tenantService.tenantApiUrl()}/${this._tenantService.tenantApiPrefix()}/${probateId}/subscribers/${subscriberId}/`,
    );
  }
}
